import React, {Component} from 'react';
import {BigButtonTool} from "../../../toolsSpace/oneLineToolSpace";
import storyLayoutImportIcon from "./storyLayout.png";
import {Modal, Radio } from "antd";
import {findObject, removeContentSecurity} from "../../../floatTool/securityCheck";
import {uuid} from "../../../../../utils";
import $ from "jquery";
import BaseComponent from "../../../../../base/BaseComponent";

const formatCss = value=>`/cm-sites/style/typeset/format${value}.css`;
const dataSourceDefault = [{
    name:"常用样式",
    list:[
        {name:"默认",value:2,href:formatCss(2)},
        {name:"大字体",value:4,href:formatCss(4)},
        {name:"保留更少格式",value:500,href:formatCss(500)},
        {name:"大字体+保留更少格式",value:501,href:formatCss(501)},
        {name:"新闻网样式",value:1001,href:formatCss(1001)}]
},{
    name:"通知样式",
    list:[
        {name:"默认",value:6,href:formatCss(6)},
        {name:"大字体",value:7,href:formatCss(7)},
        {name:"保留更少格式",value:502,href:formatCss(502)},
        {name:"大字体+保留更少格式",value:503,href:formatCss(503)}]
},{
    name:"无样式",
    list:[{name:"默认",value:1,href:formatCss(1)}]
}];

/**
 *
 * checkedId     //当前选中的
 * lastCheckedId //最后一次选中的
 * storyLayoutStyleDefaultValue //默认选中的
 * 页面打开的时候，展示默认选中的，如果修改过就展示最后一次选中的。点击确定的时候最后一次选中的才生效
 * */
class StoryLayout extends BaseComponent {

    constructor(props) {
        super(props);
        this.loadDataSource();
    }

    id = "a"+uuid();
    checkedId = 2;//当前选中的
    lastCheckedId; //最后一次选中的     storyLayoutStyleDefaultValue为默认选中的


    editorData = {};
    showData = (data)=>{
        this.editorData = data || {};
        this.state.storyLayoutStyleDefaultValue = 2;
        if(data?.variableFields){
            if(data.variableFields.formatId){
                this.checkedId = data?.variableFields?.formatId;
                let findResult = findObject(this.state.dataSource, "value", data.variableFields.formatId);
                $(this.props.editor.document).find("#thecss").attr("href", findResult?.href);
                $(this.props.editor.document.body).attr("id", `vsb_content_${data.variableFields.formatId}`);
            }
            this.state.storyLayoutStyleDefaultValue = data.variableFields.formatId || this.checkedId;
        }else{
            this.editorData.variableFields = {};
        }
        if(!this.lastCheckedId){
            this.lastCheckedId = this.state.storyLayoutStyleDefaultValue;
        }
    };

    state = {
        dialogVisible : false,
        storyLayoutStyleDefaultValue : "",
        dataSource : []
    };

    changeStoryLayoutStyle = (value)=>{

        let iframe = document.getElementById(this.id);
        if(!iframe){
            return;
        }

        let iframeDocument = iframe.contentWindow.document || iframe.document || iframe.contentDocument;
        $(iframeDocument).find(".v_news_content").attr("id", `vsb_content_${value}`);
        let findResult = findObject(this.state.dataSource, "value", value);
        $(iframeDocument).find(`#${this.id}_csspath`).attr("href", findResult.href);
        this.checkedId = value;
    };

    changeHTML = (content)=>{
        content =this.setSpecialRequirements(content)
        content = removeContentSecurity(content);
        let funs = this.sysConfigGetValueByKey("story.layout.change.html", "removeLabelStyle,addStartAndEnd,addSpecialClass,removeStyleAndPoint").split(",");
        funs && funs.map(item=>{
            let fun = require(`./${item}`).default;
            content = fun(content);
        });
        this.setClearAll(content, (newContent) => {
            content = newContent
        });
        return content;
    };

    //处理 p 里面内容以及图片拆开
    // 处理table 里面内容 拆出文字以及图片
    setSpecialRequirements(content) {
        let tempContent = JSON.parse(JSON.stringify(content));
        //处理图片内容特殊格式  p 里面有内容和图片，拆图片和内容
        //去除所有样式
        content = content.replace(/ style="[^"]*"/gi, '');
        //去除所有的div 标签换成p
        content = content.replace(/<div.*?>/g, "<p>").replace(/<\/div>/g, "</p>");
        //去除所有的a 标签
        content = content.replace(/<a.*?>|<\/a>/g, '');
        //去除所有的&nbsp
        content = content.replace(/^(?:&nbsp;|\s)+|(?:&nbsp;|\s)+$/g, '');

        // 解决p 标签里面的 文字和图片抽离出来
        content = content.replace(/<img/g, '<p></p><img');
        content = content.replace(/\/>/g, '/><p></p>');
        let editor = this.props.editor;
        // 解决table 里面的 文字和图片抽离
        content=content.replace(/<table[^>]*>/g, '<p>').replace(/<\/table>/g, '</p>');
        content=content.replace(/<tbody[^>]*>/g, '<p>').replace(/<\/tbody>/g, '</p>');
        content=content.replace(/<thead[^>]*>/g, '<p>').replace(/<\/thead>/g, '</p>');
        content=content.replace(/<th[^>]*>/g, '<p>').replace(/<\/th>/g, '</p>');
        content=content.replace(/<tr[^>]*>/g, '<p>').replace(/<\/tr>/g, '</p>');
        content=content.replace(/<td[^>]*>/g, '<p>').replace(/<\/td>/g, '</p>');
        content=content.replace(/<tfoot[^>]*>/g, '<p>').replace(/<\/tfoot>/g, '</p>');
        content=content.replace(/<col[^>]*>/g, '<p>').replace(/<\/col>/g, '</p>');
        content=content.replace(/<caption[^>]*>/g, '<p>').replace(/<\/caption>/g, '</p>');
        content=content.replace(/<colgroup[^>]*>/g, '<p>').replace(/<\/colgroup>/g, '</p>');


        // 借助编辑器解析特殊 文字，图片内容
        editor.setContent(JSON.parse(JSON.stringify(content)));
        content = editor.getContent();
        editor.setContent(tempContent);
        content = content.replace(/<p[^>]*>[<br\/>]*<\/p>/g,'');
        //p 里面有内容和图片，拆图片和内容
        return content
    }

    //清楚所有样式
    setClearAll(content, call) {
        let currentContent = $(content);
        let formatIds = [10011];//添加图片下面文字居中的模板iD,10011 强军网样式模板；
        let newContent = content;
        //特殊处理图片下的文字按要求居中
        let isImg = false;
        if (content && content.length) {
            let id = `tempId${uuid()}`;
            $('body').append('<div id="' + id + '" style="display: none"></div>');
            for (let i = 0; i < currentContent.length; i++) {
                let item = currentContent[i];
                let currentPClassName = item.className;
                let currentImgDome = $(item);
                // $('#tempId').append(item)
                if ($(item).hasClass('vsbcontent_img')) {
                    // $('#tempId').append(item)
                    isImg = $(item).hasClass('vsbcontent_img');
                    console.log(currentPClassName);
                    let imgList = currentImgDome.find('img');
                    if (imgList.length) {
                        for (let j = 0; j < imgList.length; j++) {
                            let parentElement = $('<p class="'+currentPClassName+'" style="text-indent: 0px;text-align:center "></p>');
                            // 将img元素添加到父元素中
                            parentElement.append(imgList[j]);
                            $('#' + id).append(parentElement.prop('outerHTML'))
                        }
                    } else if (item.innerText) {
                        $('#'+id).append('<p  class="'+currentPClassName+'"style="text-align: center;text-indent: 0">' + item.innerText + '</p>');
                        isImg = false;
                    }
                } else {
                    let currentText = item.innerText;
                    if (currentText
                        && $(item).find('img').length == 0
                        && $(item).find('video').length == 0
                        && $(item).find('audio').length == 0
                        && $(item).find('iframe').length == 0
                        && $(item).find('.katex-mathml').length == 0
                    ) {
                        /**
                         * currentPClassName
                         * 一键排版时会给元素添加类名，需要保留
                         * */
                        currentText = currentText ? currentText.replace(/(^\s*)|(\s*$)/g, '') : "";
                        // const currentInnerHTML = item.innerHTML;
                        //编辑器内容图片下面有文字的话，多少个文字标识为图说，是0 的时候不表示为图说，比如配置为31，小于31的时候，图片下面的文字认为它是图说
                        let editImgSummaryNum =   window.sysConfigGetValueByKey('editImgSummaryNum',);
                        console.log(editImgSummaryNum,'editImgSummaryNum',parseInt(editImgSummaryNum)>0)
                        if(parseInt(editImgSummaryNum)>0){
                            if (isImg && /*formatIds.indexOf(this.checkedId) > -1 &&*/ (currentText.length && currentText.length < editImgSummaryNum)) {
                                $('#'+id).append('<p class="'+currentPClassName+'" style="text-align: center;text-indent: 0">' + currentText + '</p>')
                            } else {
                                if (currentText && currentText.length) {
                                    $('#'+id).append('<p class="'+currentPClassName+'" >' + currentText + '</p>')
                                }
                            }
                        }else{
                            if (currentText && currentText.length) {
                                $('#'+id).append('<p class="'+currentPClassName+'" >' + currentText + '</p>')
                            }
                        }
                        isImg = false
                    } else if (item.tagName !== "BR" && $(item).find('.vsbcontent_img').length && item.childNodes.length /*&& formatIds.indexOf(this.checkedId) > -1*/) {
                        // 这里之所以判断$(item).find('.vsbcontent_img').length进行递归操作的原因是，发现存在稿件图片html层级嵌套
                        // 很深的情况，要达到强军网一键排版后标题图居中效果必须深层递归处理
                        this.fillDeepNodeFormat(id, item.children);
                    } else if (item.tagName !== "BR") {
                        $('#'+id).append(item.outerHTML);
                    }
                }
            }
            newContent = $('#' + id).html();
            $('#' + id).remove();
        }
        call && call(newContent);
    }

    fillDeepNodeFormat = (id, deepNodeList) => {
        let isImg = false;
        for (let i = 0; i < deepNodeList.length; i++) {
            const nodeDom = deepNodeList[i];
            if ($(nodeDom).find('img').length && nodeDom.innerText.trim() != '') {
                // $('#'+id).append(nodeDom.innerHTML);
                this.fillDeepNodeFormat(id, nodeDom.children);
            } else if ($(nodeDom).find('img').length && nodeDom.innerText.trim() == '') {
                $('#'+id).append(nodeDom.outerHTML);
                isImg = true;
            } else if (nodeDom.innerText != '' && isImg) {
                let currentText = nodeDom.innerText.trim();
                //编辑器内容图片下面有文字的话，多少个文字标识为图说，是0 的时候不表示为图书，比如配置为31，小于31的时候，图片下面的文字认为它是图说
                let editImgSummaryNum =   window.sysConfigGetValueByKey('editImgSummaryNum',0);
                if(parseInt(editImgSummaryNum)>0){
                    if (isImg && /*formatIds.indexOf(this.checkedId) > -1 &&*/ (currentText.length && currentText.length < editImgSummaryNum)) {
                        $('#' + id).append('<p style="text-align: center;text-indent: 0">' + currentText + '</p>')
                    } else {
                        if (currentText && currentText.length) {
                            $('#' + id).append('<p>' + currentText + '</p>')
                        }
                    }
                }else{
                    if (currentText && currentText.length) {
                        $('#' + id).append('<p>' + currentText + '</p>')
                    }
                }
                // $('#'+id).append('<p style="text-align: center;text-indent: 0">' + currentText + '</p>');
                isImg = false;
            } else {
                $('#'+id).append(nodeDom.outerHTML);
            }
        }
    }


    writeIframeContent = (content)=>{
        let iframe = document.getElementById(this.id);
        if(!iframe){
            return;
        }
        let iframeDocument = iframe.contentWindow.document || iframe.document || iframe.contentDocument;
        iframeDocument.location.href = "about:blank";
        let newContent = this.changeHTML(content);
        let findResult = findObject(this.state.dataSource, "value", this.checkedId);
        setTimeout(()=>{
            let iframeDocument = iframe.contentWindow.document || iframe.document || iframe.contentDocument;
            iframeDocument.write(`<head>
                                    <style>
                                        body {background: #fff}
                                        ::-webkit-scrollbar {width:5px;}
                                        //* 滚动槽 */
                                        ::-webkit-scrollbar-track {
                                            border-radius:5px;
                                        }
                                        //* 滚动条滑块 */
                                        ::-webkit-scrollbar-thumb {
                                            border-radius:10px;
                                            background: #bbc0c7;
                                        }
                                        ::-webkit-scrollbar-thumb:window-inactive {
                                            background: #bbc0c7;
                                        }
                                     </style><link rel='stylesheet' Content-type='text/css' id='${this.id}_csspath' href='${findResult.href}'></head><body class='v_news_content' id='vsb_content_${this.checkedId}'></body>`);
            $(iframeDocument).find(`#vsb_content_${this.checkedId}`).html(newContent);
        }, 10);
    };

    loadDataSource = ()=>{
        let dataSource = JSON.parse(this.sysConfigGetValueByKey("story.layout.data.source", JSON.stringify(dataSourceDefault)));
        this.state.dataSource = dataSource;
    };

    modalKey = "a"+uuid();
    render() {
        let editor = this.props.editor;
        return (
            <div>
                <BigButtonTool float={this.props.float} style={this.props.style} src={storyLayoutImportIcon} text={"一键排版"} imgWidth={this.props.width}
                               onClick={()=>{
                                   this.setState({dialogVisible: true},()=>{
                                       let content = editor.getContent() || "";
                                       content = removeContentSecurity(content);
                                       setTimeout(()=>this.writeIframeContent(content), 10);
                                   })
                               }}
                />
                <Modal
                    key={this.modalKey}
                    maskClosable={false}
                    title={"一键排版"}
                    visible={this.state.dialogVisible}
                    onCancel={()=>{
                        this.modalKey = "a"+uuid();
                        this.changeStoryLayoutStyle(this.lastCheckedId)
                        this.setState({dialogVisible: false});
                    }}
                    onOk={()=>{
                        this.editorData.variableFields.formatId = this.checkedId;
                        this.lastCheckedId = this.checkedId;
                        let findResult = findObject(this.state.dataSource, "value", this.checkedId);
                        $(editor.document).find("#thecss").attr("href", findResult.href);
                        $(editor.document.body).attr("id", `vsb_content_${this.checkedId}`);
                        editor.setContent(this.changeHTML(editor.getContent()));
                        this.setState({dialogVisible: false});
                    }}
                    width={960}
                    bodyStyle={{padding:15, background:"#f5f8fc"}}
                >
                    <div style={{width:"100%",background:"#fff",padding:15}}>
                        {this.lastCheckedId && <Radio.Group name="radioGroup" onChange={(e)=>{
                            // let checkedId = e.target.value;
                            // let findResult = findObject(this.state.dataSource, "value", checkedId);
                            // $(editor.document).find("#thecss").attr("href", findResult.href);
                            this.changeStoryLayoutStyle(e.target.value)
                        }} defaultValue={this.lastCheckedId}>
                            {this.state.dataSource && this.state.dataSource.map((item,index)=>{
                                return <div key={index} style={{marginBottom:5}}><span style={{marginRight:5,width:80,display:"inline-block"}}>{item.name}：</span>
                                    {
                                        item.list && item.list.map((son, sonIndex) => {
                                            return <Radio key={"son_"+index+"_"+sonIndex} value={son.value}>{son.name}</Radio>;
                                        })
                                    }
                                </div>
                            })}
                        </Radio.Group>}
                    </div>
                    <div style={{width:"100%",marginTop:"15px",background:"#fff",padding:15}}>
                        <iframe
                            width={900}
                            style={{height:(()=>{
                                let newHeight = document.body.clientHeight - 500;
                                    newHeight = newHeight < 400 ? 400 : newHeight;
                                    return newHeight;
                            })()}}
                            src={"about:blank"}
                            frameBorder={0}
                            id={this.id}
                            onLoad={()=>{
                            }}
                        >
                        </iframe>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default StoryLayout;